<template>
  <div class="container mb-5">
    <div class="row" v-if="!request_mode">
      <div class="col-8">
        <div>情報</div>
        <!-- {{ app_data }} -->
        <div class="container mb-4 pt-2 border border-2">
          <div class="row mb-2 border-bottom">
            <div class="col-3">ログインID</div>
            <div class="col-6">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_data@login_id') || {})
                    .application_value
                }}
              </p>
            </div>
          </div>
          <div class="row mb-2 border-bottom">
            <div class="col-3">ログインパス</div>
            <div class="col-6">
              <p class="form-control-plaintext">
                *********
                <!-- {{
                  (get_app_item('mfj_member_data@login_pass') || {})
                    .application_value
                }} -->
              </p>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">ライセンスNo</div>
            <div class="col-4" v-if="regist_data.m_id == 0">
              <input
                type="text"
                :value="(get_license_no_stock || {}).license_no"
                class="form-control"
                :readonly="request_license_no_readonly"
              />
            </div>
            <div class="col-4" v-else>
              <input
                type="text"
                :value="(app_data || {}).license_no"
                class="form-control-plaintext"
                :readonly="request_license_no_readonly"
              />
            </div>
            <!-- <div class="col-4" v-if="edit_mode">
              <input
                type="text"
                v-model="request_license_no"
                class="form-control"
                :readonly="request_license_no_readonly"
              />
            </div>
            <div class="col-4" v-else>
              <p class="form-control-plaintext" v-if="request_license_no">
                {{ request_license_no }}
              </p>
              <p class="form-control-plaintext" v-else>-未設定-</p>
            </div>
            <div class="col-5" v-if="edit_mode && get_license_no_stock">
              <div class="input-group">
                <button
                  class="btn btn-light btn-outline-secondary"
                  @click="use_stock"
                  v-if="stock_action_sw"
                >
                  <i class="bi bi-arrow-left"></i>
                </button>
                <button
                  class="btn btn-light btn-outline-secondary"
                  @click="cancel_stock"
                  v-else
                >
                  <i class="bi bi-x"></i>
                </button>
                <input
                  type="text"
                  v-model="get_license_no_stock.license_no"
                  class="form-control"
                  readonly="readonly"
                  v-if="stock_action_sw"
                />
                <input
                  type="text"
                  :value="'設定済'"
                  class="form-control"
                  readonly="readonly"
                  v-else
                />
              </div>
            </div> -->
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">氏名</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_data@name_1') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_data@name_2') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_name')"
                  @click="toggle_check_action('m_name')"
                >
                  <i :class="get_class_check_item_icon('m_name')"></i>
                </button>
              </div>
            </div>
            <div class="col-12" v-if="chk_same_name_and_birthday">
              <p class="text-danger">
                同一の氏名・生年月日の会員が存在しています。
              </p>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">氏名 カナ</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_data@yomi_1') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_data@yomi_2') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_yomi')"
                  @click="toggle_check_action('m_yomi')"
                >
                  <i :class="get_class_check_item_icon('m_yomi')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">生年月日</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_data@birth_date') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                和暦{{
                  get_wareki_bs(
                    (get_app_item('mfj_member_data@birth_date') || {})
                      .application_value
                  )
                }}
              </p>
            </div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_birth_date')"
                  @click="toggle_check_action('m_birth_date')"
                >
                  <i :class="get_class_check_item_icon('m_birth_date')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">年齢(競技年齢)</div>
            <div class="col-4">
              <p class="form-control-plaintext" v-if="currentSportsYear">
                {{
                  calc_sports_age(
                    get_app_item('mfj_member_data@birth_date')
                      .application_value,
                    currentSportsYear
                  )
                }}
              </p>
              <p v-else>競技年齢が計算できません。</p>
            </div>
            <div class="col-4"></div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">性別</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  get_list_label(
                    (get_app_item('mfj_member_data@sex_type') || {})
                      .application_value,
                    sex_type_cd
                  )
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_sex_type')"
                  @click="toggle_check_action('m_sex_type')"
                >
                  <i :class="get_class_check_item_icon('m_sex_type')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">郵便番号</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_profile@postal_cd') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div v-if="false">
                <button
                  :class="get_class_check_item_btn('m_address')"
                  @click="toggle_check_action('m_address')"
                >
                  <i :class="get_class_check_item_icon('m_address')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">都道府県</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  get_list_label(
                    (get_app_item('mfj_member_profile@pref_cd') || {})
                      .application_value,
                    PREF_CD_LIST
                  ) || ''
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1"></div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">市区町村・番地</div>
            <div class="col-8">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_profile@address_1') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">建物名・室号</div>
            <div class="col-8">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_profile@address_2') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">連絡先電話番号1</div>
            <div class="col-6">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_profile@tel_1') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-2"></div>
            <div class="col-1">
              <div v-if="false">
                <button
                  :class="get_class_check_item_btn('m_tel_1')"
                  @click="toggle_check_action('m_tel_1')"
                >
                  <i :class="get_class_check_item_icon('m_tel_1')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">連絡先電話番号2</div>
            <div class="col-6">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_profile@tel_2') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-2"></div>
            <div class="col-1">
              <div v-if="false">
                <button
                  :class="get_class_check_item_btn('m_tel_2')"
                  @click="toggle_check_action('m_tel_2')"
                >
                  <i :class="get_class_check_item_icon('m_tel_2')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">メールアドレス</div>
            <div class="col-6">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_profile@mail_1') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-2"></div>
            <div class="col-1"></div>
          </div>
          <div class="row mb-2 pb-2" v-if="false">
            <div class="col-3">本人確認書類</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  get_list_label(
                    (get_app_item('mfj_member_data@identify_type') || {})
                      .application_value,
                    member_document_cd
                  )
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_identify_type')"
                  @click="toggle_check_action('m_identify_type')"
                >
                  <i :class="get_class_check_item_icon('m_identify_type')"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="join_3hour_frm_disp">3時間走行証明</div>
        <div class="mb-4 pt-2 border border-2" v-if="join_3hour_frm_disp">
          <div
            class="container mb-2 border-bottom"
            v-for="variant in get_selected_variants_filter(
              { join_3hour: 1 },
              {},
              1
            )"
            :key="variant"
          >
            <div class="row border-bottom border-dotted">
              <div class="col-4 mb-2">
                {{ variant.license_label }}
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary">公認サーキット</label>
                <input
                  :value="
                    get_list_label(variant.join_3hour_circuit_id, circuit_list)
                  "
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary"
                  >サーキットライセンスNo.</label
                >
                <input
                  :value="variant.join_3hour_circuit_license_no"
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
              <div class="col-4 offset-4 mb-2">
                <label class="badge bg-secondary">ライセンス画像</label>
                <div
                  class="w-100"
                  v-if="
                    typeof get_app_item('mfj_member_assets@path10') ===
                      'object' &&
                    isImage(
                      get_app_item('mfj_member_assets@path10').application_value
                    )
                  "
                >
                  <ImageWithZoom
                    :image-src="
                      (get_app_item('mfj_member_assets@path10') || {})
                        .application_value || ''
                    "
                    image-class="w-100"
                    image-alt="ライセンス画像"
                    modal-title="ライセンス画像"
                    :loading="false"
                    @error="handleImageError"
                  />
                </div>
                <div
                  v-else-if="
                    typeof get_app_item('mfj_member_assets@path10') === 'object'
                  "
                  class="text-muted"
                >
                  <a
                    :href="
                      get_app_item('mfj_member_assets@path10').application_value
                    "
                    target="_blank"
                    >書類を確認</a
                  >
                </div>
                <div v-else>未提出</div>
              </div>
              <div class="col-4 mb-2">
                <!-- <label class="badge bg-secondary"
                  >サーキットライセンス講習会専用申請書、3時間走行証明書、競技会成績証明書</label
                > -->
                <label class="badge bg-secondary">提出書類</label>

                <div
                  class="w-100"
                  v-if="
                    typeof get_app_item('mfj_member_assets@path11') ===
                      'object' &&
                    isImage(
                      get_app_item('mfj_member_assets@path11').application_value
                    )
                  "
                >
                  <ImageWithZoom
                    :image-src="
                      (get_app_item('mfj_member_assets@path11') || {})
                        .application_value || ''
                    "
                    image-class="w-100"
                    image-alt="提出書類"
                    modal-title="提出書類"
                    :loading="false"
                    @error="handleImageError"
                  />
                </div>
                <div
                  v-else-if="
                    typeof get_app_item('mfj_member_assets@path11') === 'object'
                  "
                  class="text-muted"
                >
                  <a
                    :href="
                      get_app_item('mfj_member_assets@path11').application_value
                    "
                    target="_blank"
                    >書類を確認</a
                  >
                </div>
                <div v-else>未提出</div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">サーキット確認関連</div>
              <div class="col-8">
                <table class="table table-bordered w-100">
                  <tr>
                    <th>3時間走行確認依頼日時</th>
                    <th>3時間走行確認MFJ依頼者</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_req_date
                          ? variant.join_3hour_circuit_chk_req_date
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_req_manage_id
                          ? variant.join_3hour_circuit_chk_req_manage_label
                          : app_data.edit_manage_label
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th>サーキット担当者</th>
                    <th>返答日時</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_signature
                          ? variant.join_3hour_circuit_chk_ans_signature
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_date
                          ? variant.join_3hour_circuit_chk_ans_date
                          : '--'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th>返答1</th>
                    <th>返答2</th>
                  </tr>
                  <tr>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_data_1
                          ? variant.join_3hour_circuit_chk_ans_data_1 == 1
                            ? '該当者有り'
                            : '該当者無し'
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        variant.join_3hour_circuit_chk_ans_data_2
                          ? parseInt(
                              variant.join_3hour_circuit_chk_ans_data_2
                            ) == 1
                            ? variant.license_id == 2
                              ? '適切なライセンスを保有している'
                              : '3時間以上'
                            : variant.license_id == 2
                            ? '適切なライセンスを保有していない'
                            : '3時間未満'
                          : '--'
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row mb-2 pb-2">
              <div
                class="col-1 offset-11"
                v-if="chk_checked_item('m_join_3hour')"
              >
                <div>
                  <button
                    :class="get_class_check_item_btn('m_join_3hour')"
                    @click="toggle_check_action('m_join_3hour')"
                  >
                    <i :class="get_class_check_item_icon('m_join_3hour')"></i>
                  </button>
                </div>
              </div>
              <div v-else class="col-3 offset-9">
                <div class="d-grid mb-2" v-if="!join_3hour_frm_circuit_chk_ok">
                  <button
                    v-if="edit_mode"
                    type="button"
                    class="btn btn-info"
                    @click="app_send_circuit_check()"
                  >
                    確認依頼を開く
                  </button>
                </div>
                <div class="" v-else>
                  <button
                    :class="get_class_check_item_btn('m_join_3hour')"
                    @click="toggle_check_action('m_join_3hour')"
                  >
                    <i :class="get_class_check_item_icon('m_join_3hour')"></i>
                    チェック完了
                  </button>
                </div>
                <div
                  class=""
                  v-if="!join_3hour_frm_circuit_chk_ok && edit_mode"
                >
                  <button
                    :class="get_class_check_item_btn('m_join_3hour')"
                    @click="toggle_check_action('m_join_3hour')"
                  >
                    <i :class="get_class_check_item_icon('m_join_3hour')"></i>
                    確認依頼を事後扱いで承認を進める
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="join_seminar_circuit_chk_disp">講習会</div>
        <div
          class="mb-4 pt-2 border-top border-start border-2"
          v-if="join_seminar_circuit_chk_disp"
        >
          <div
            class="container mb-2 border-bottom"
            v-for="variant in get_selected_variants_filter(
              {
                join_seminar_type: 'circuit'
              },
              {},
              false
            )"
            :key="variant"
          >
            <div class="row border-bottom border-dotted">
              <div class="col-4 mb-2">
                {{ variant.license_label }}
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary">受講した施設名</label>
                <input
                  :value="variant.join_seminar_place"
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
              <div class="col-4 mb-2">
                <label class="badge bg-secondary">受講日</label>
                <input
                  :value="variant.join_seminar_date"
                  class="form-control-plaintext"
                  readonly="true"
                />
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div
              class="col-1 offset-11"
              v-if="chk_checked_item('m_join_seminar')"
            >
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_join_seminar')"
                  @click="toggle_check_action('m_join_seminar')"
                >
                  <i :class="get_class_check_item_icon('m_join_seminar')"></i>
                </button>
              </div>
            </div>
            <div v-else class="col-2 offset-10">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('m_join_seminar')"
                  @click="toggle_check_action('m_join_seminar')"
                >
                  <i :class="get_class_check_item_icon('m_join_seminar')"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div>写真・書類</div>
        <!-- 顔写真 -->
        <div class="py-2 px-1 mb-2 border">
          <div class="row">
            <div class="col-12 mb-2">顔写真</div>
            <div class="col-12 col-md-10">
              <div
                class="w-100"
                v-if="
                  typeof get_app_item('mfj_member_assets@path3') === 'object' &&
                  isImage(
                    get_app_item('mfj_member_assets@path3').application_value
                  )
                "
              >
                <ImageWithZoom
                  :image-src="
                    (get_app_item('mfj_member_assets@path3') || {})
                      .application_value || ''
                  "
                  image-class="w-100"
                  image-alt="顔写真"
                  modal-title="顔写真"
                  :loading="false"
                  @error="handleImageError"
                />
              </div>
              <div
                v-else-if="
                  typeof get_app_item('mfj_member_assets@path3') === 'object'
                "
                class="text-muted"
              >
                <a
                  :href="
                    get_app_item('mfj_member_assets@path3').application_value
                  "
                  target="_blank"
                  >写真を確認</a
                >
              </div>
              <div v-else>未提出</div>
            </div>
            <div class="col-12 col-md-2">
              <div class="text-end">
                <div v-if="edit_mode">
                  <button
                    :class="get_class_check_item_btn('m_photo')"
                    @click="toggle_check_action('m_photo')"
                  >
                    <i :class="get_class_check_item_icon('m_photo')"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-2 px-1 mb-2 border">
          <div class="row">
            <div class="col-12 mb-2">本人確認書類</div>
            <div class="col-12 mb-2">
              <p class="form-control-plaintext">
                {{
                  get_list_label(
                    (get_app_item('mfj_member_data@identify_type') || {})
                      .application_value,
                    member_document_cd
                  )
                }}
              </p>
            </div>
            <div class="col-12 col-md-10">
              <div v-for="k in [1, 2]" :key="k">
                <div
                  class="w-100"
                  v-if="
                    typeof get_app_item('mfj_member_assets@path' + k) ===
                      'object' &&
                    isImage(
                      get_app_item('mfj_member_assets@path' + k)
                        .application_value
                    )
                  "
                >
                  <ImageWithZoom
                    :image-src="
                      (get_app_item('mfj_member_assets@path' + k) || {})
                        .application_value || ''
                    "
                    image-class="w-100"
                    :image-alt="`本人提出書類${k}`"
                    :modal-title="`本人提出書類${k}の画像`"
                    :loading="false"
                    @error="handleImageError"
                  />
                </div>
                <div
                  v-else-if="
                    typeof get_app_item('mfj_member_assets@path' + k) ===
                    'object'
                  "
                  class="text-muted"
                >
                  <a
                    :href="
                      get_app_item('mfj_member_assets@path' + k)
                        .application_value
                    "
                    target="_blank"
                    >書類を確認</a
                  >
                </div>
                <div v-else>未提出</div>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="text-end">
                <div v-if="edit_mode">
                  <button
                    :class="get_class_check_item_btn('m_idcard_photo')"
                    @click="on_check_wrap_action('m_idcard_photo')"
                  >
                    <i :class="get_class_check_item_icon('m_idcard_photo')"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-2 px-1 mb-2 border" v-if="rd_frm_disp">
          <div class="row">
            <div class="col-12 mb-2">サーキットライセンス</div>
            <div class="col-12 col-md-10">
              <ImageWithZoom
                v-if="
                  typeof get_app_item('mfj_member_assets@path3') === 'object'
                "
                :image-src="
                  (get_app_item('mfj_member_assets@path3') || {})
                    .application_value || ''
                "
                image-class="w-100"
                image-alt="サーキットライセンス"
                modal-title="サーキットライセンス"
                :loading="false"
                @error="handleImageError"
              />
              <div v-else class="alert alert-secondary">未提出</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="container mb-4 pt-2 border border-2" v-if="parent_frm_disp">
          <div class="h5">親権者情報</div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">親権者 氏名</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_parent@name_1') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_parent@name_2') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('parent_name')"
                  @click="toggle_check_action('parent_name')"
                >
                  <i :class="get_class_check_item_icon('parent_name')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">親権者 氏名カナ</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_parent@yomi_1') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_parent@yomi_2') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('parent_yomi')"
                  @click="toggle_check_action('parent_yomi')"
                >
                  <i :class="get_class_check_item_icon('parent_yomi')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">親権者 性別</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  get_list_label(
                    (get_app_item('mfj_member_parent@sex_type') || {})
                      .application_value,
                    sex_type_cd
                  )
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('parent_sex_type')"
                  @click="toggle_check_action('parent_sex_type')"
                >
                  <i :class="get_class_check_item_icon('parent_sex_type')"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">親権者 生年月日</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  formatBirthDate(
                    get_app_item('mfj_member_parent@birth_date')
                      ?.application_value
                  )
                }}
              </p>
            </div>
            <div class="col-4">
              <p class="form-control-plaintext">
                和暦{{
                  formatWarekiDate(
                    get_app_item('mfj_member_parent@birth_date')
                      ?.application_value
                  )
                }}
              </p>
            </div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('parent_birth_date')"
                  @click="toggle_check_action('parent_birth_date')"
                >
                  <i
                    :class="get_class_check_item_icon('parent_birth_date')"
                  ></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom" v-if="false">
            <div class="col-3">親権者 確認書類</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  get_list_label(
                    (
                      get_app_item('mfj_member_parent@parent_identify_type') ||
                      {}
                    ).application_value,
                    member_document_cd
                  )
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div v-if="edit_mode">
                <button
                  :class="get_class_check_item_btn('parent_identify_type')"
                  @click="toggle_check_action('parent_identify_type')"
                >
                  <i
                    :class="get_class_check_item_icon('parent_identify_type')"
                  ></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">親権者 MFJライセンスNo</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_member_parent@license_no') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div v-if="false">
                <button
                  :class="get_class_check_item_btn('parent_license_no')"
                  @click="toggle_check_action('parent_license_no')"
                >
                  <i
                    :class="get_class_check_item_icon('parent_license_no')"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="container mb-4 border border-2"
          v-if="parent_accept_disp && edit_mode"
        >
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">競技参加承諾書</div>
            <div class="col-8">
              <p>参加承諾書の確認をしてください</p>
            </div>
            <div class="col-1">
              <div>
                <button
                  :class="get_class_check_item_btn('parent_accept')"
                  @click="toggle_check_action('parent_accept')"
                >
                  <i :class="get_class_check_item_icon('parent_accept')"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="container mb-4" v-if="parent_frm_disp">
          <div class="py-2 px-1 mb-2 border" v-if="parent_frm_disp">
            <div class="row">
              <div class="col-12 mb-2">親権者確認書類</div>
              <div class="col-12 col-md-10">
                <div v-for="k in [4, 5]" :key="k">
                  <ImageWithZoom
                    v-if="
                      typeof get_app_item('mfj_member_assets@path' + k) ===
                        'object' &&
                      isImage(
                        (get_app_item('mfj_member_assets@path' + k) || {})
                          .application_value
                      )
                    "
                    :image-src="
                      (get_app_item('mfj_member_assets@path' + k) || {})
                        .application_value || ''
                    "
                    image-class="w-100"
                    :image-alt="`親権者確認書類${k - 3}`"
                    :modal-title="`親権者確認書類${k - 3}の詳細表示`"
                    :loading="false"
                    @error="handleImageError"
                    class="mb-3"
                  />
                  <div
                    v-else-if="
                      typeof get_app_item('mfj_member_assets@path' + k) ===
                      'object'
                    "
                    class="text-muted"
                  >
                    <a
                      :href="
                        get_app_item('mfj_member_assets@path' + k)
                          .application_value
                      "
                      target="_blank"
                      >書類を確認</a
                    >
                  </div>
                  <div v-else class="alert alert-secondary mb-3">未提出</div>
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="text-end">
                  <div v-if="edit_mode">
                    <button
                      :class="get_class_check_item_btn('parent_idcard_photo')"
                      @click="on_check_wrap_action('parent_idcard_photo')"
                    >
                      <i
                        :class="
                          get_class_check_item_icon('parent_idcard_photo')
                        "
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="py-2 px-1 mb-2 border" v-if="parent_frm_disp">
            <div class="row">
              <div class="col-12 mb-2">親権者顔写真</div>
              <div class="col-12 col-md-10">
                <ImageWithZoom
                  v-if="
                    typeof get_app_item('mfj_member_assets@path6') ===
                      'object' &&
                    isImage(
                      (get_app_item('mfj_member_assets@path6') || {})
                        .application_value
                    )
                  "
                  :image-src="
                    (get_app_item('mfj_member_assets@path6') || {})
                      .application_value || ''
                  "
                  image-class="w-100"
                  image-alt="親権者顔写真"
                  modal-title="親権者顔写真"
                  :loading="false"
                  @error="handleImageError"
                  class="mb-3"
                />
                <div
                  v-else-if="
                    typeof get_app_item('mfj_member_assets@path6') === 'object'
                  "
                  class="text-muted"
                >
                  <a
                    :href="
                      get_app_item('mfj_member_assets@path6').application_value
                    "
                    target="_blank"
                    >書類を確認</a
                  >
                </div>
                <div v-else class="alert alert-secondary">未提出</div>
              </div>
              <div class="col-12 col-md-2">
                <div class="text-end">
                  <div v-if="edit_mode">
                    <button
                      :class="get_class_check_item_btn('parent_photo')"
                      @click="toggle_check_action('parent_photo')"
                    >
                      <i :class="get_class_check_item_icon('parent_photo')"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-8">
        <div>ライセンス情報</div>
        <div class="container mb-4 border border-2">
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">過去のライセンス</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  get_list_label(
                    (get_app_item('mfj_outdb_data@past_license_chk') || {})
                      .application_value,
                    ownchk_list
                  )
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div></div>
            </div>
          </div>
          <div class="row mb-2 pb-2 border-bottom">
            <div class="col-3">過去のライセンスNo.</div>
            <div class="col-4">
              <p class="form-control-plaintext">
                {{
                  (get_app_item('mfj_outdb_data@past_license_no') || {})
                    .application_value
                }}
              </p>
            </div>
            <div class="col-4"></div>
            <div class="col-1">
              <div></div>
            </div>
          </div>
        </div>
        <div>入会費用</div>
        <div class="container mb-4 border border-2">
          <div
            class="row my-2 border-bottom"
            v-for="draft_order in draft_orders"
            :key="draft_order"
          >
            <div class="col-6">
              <p
                class="form-control-plaintext"
                v-if="draft_order.license_label"
              >
                {{ draft_order.license_label }}
                <span
                  v-if="
                    draft_order.sub_license_id > 0 &&
                    draft_order.sub_license_label != ''
                  "
                >
                  ・{{ draft_order.sub_license_label }}
                </span>
              </p>
              <p
                class="form-control-plaintext"
                v-else-if="draft_order.sub_label"
              >
                {{ draft_order.sub_label }}
              </p>
            </div>
            <div class="col-2">
              <p class="form-control-plaintext">
                <span v-if="draft_order.sports_year"
                  >({{ draft_order.sports_year }})</span
                >
              </p>
            </div>
            <div class="col-2">
              <p class="form-control-plaintext">
                {{ draft_order.unit_price }}
              </p>
            </div>
            <div class="col-2">
              <input
                type="text"
                v-model="draft_order.list_price"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div>対応履歴</div>
        <div class="container mb-4 border border-2">
          <div
            class="row mb-2 pb-2 border-bottom"
            v-if="(app_data || {}).communications"
          >
            <table class="table w-100">
              <thead>
                <tr>
                  <th style="width: 20%">対応日時</th>
                  <th style="width: 12%">対応者</th>
                  <th style="width: auto">対応内容</th>
                  <th style="width: 14%" class="text-center">詳細</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="communication in communication_sort"
                  :key="communication"
                >
                  <td>{{ communication.cre_date_label }}</td>
                  <td>{{ communication.manage_label }}</td>
                  <td>
                    <p class="">{{ communication.comment }}</p>
                    <div
                      v-if="chk_items_disp(communication.id)"
                      class="border-top mt-2 pt-2"
                    >
                      <div
                        class="row mb-1 pb-1 border-bottom"
                        v-for="item in communication.items"
                        :key="item"
                      >
                        <div class="col-3">
                          {{
                            get_list_label(
                              item.application_check_cd,
                              app_check_items
                            )
                          }}
                        </div>
                        <div class="col-2">
                          {{ item.check_flg == 1 ? 'OK' : 'NG' }}
                        </div>
                        <div class="col-7">{{ item.item_comment }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-grid">
                      <button
                        type="button"
                        class="btn-sm btn btn-light btn-outline-secondary"
                        @click="toggle_communication(communication.id)"
                      >
                        {{
                          chk_items_disp(communication.id) ? '閉じる' : '確認'
                        }}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center">
              <button
                type="button"
                class="btn-sm btn btn-light btn-outline-secondary"
                @click="toggle_communication_max()"
              >
                {{ app_com_max_disp ? '閉じる' : '全件表示' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>申請情報</div>
        <div class="container mb-4 border border-2 py-2">
          <div class="row">
            <div class="col-4">TOKEN</div>
            <div class="col-8">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :value="regist_data?.token"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="birthdate_is_valid">
      <div class="col-12">
        <div class="alert alert-warning">
          生年月日が不正です。<br />
          データに不備がある可能性があります。
        </div>
      </div>
    </div>
    <div class="row" v-else-if="request_mode">
      <div class="col-10">
        <div></div>
        <div v-if="request_join">
          <!-- {{ join_license_obj }} -->
          <div class="container">
            <div class="row mb-2">
              <div class="col-5">ライセンスNo</div>
              <div class="col-5">
                <input
                  type="text"
                  v-model="join_obj.license_no"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">所属(MFJ)</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.affiliation"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">ログインID</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.login_id"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">ログインパス</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.login_pass"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">姓・名</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.name_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_obj.name_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">セイ・メイ</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.yomi_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_obj.yomi_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">生年月日</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.birth_date"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">性別</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    :value="get_list_label(join_obj.sex_type, sex_type_cd)"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">郵便番号・都道府県</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_profile_obj[0].postal_cd"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_profile_obj[0].pref_cd"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">市区町村</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].address_1"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">建物名・番</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].address_2"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">連絡先電話番号1</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].tel_1"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">連絡先電話番号2</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].tel_2"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">メールアドレス1</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_profile_obj[0].mail_1"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">本人確認書類</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_obj.identify_type"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">顔写真</div>
              <div class="col-7">
                <input
                  type="text"
                  v-model="join_assets_obj[0].identify_type"
                  :class="input_class_join"
                  :readonly="input_readonly_join"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">サーキット名/ライセンス</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_circuit_license_obj[0].circuit_id"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_circuit_license_obj[0].circuit_license_no"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">入会申請日/承認日</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_obj.application_date"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_obj.permission_date"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-2" v-if="parent_frm_disp">
              <div class="col-5">親権者:姓・名</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_parent_obj[0].name_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_parent_obj[0].name_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2" v-if="parent_frm_disp">
              <div class="col-5">親権者:セイ・メイ</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="join_parent_obj[0].yomi_1"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                  <input
                    type="text"
                    v-model="join_parent_obj[0].yomi_2"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2" v-if="parent_frm_disp">
              <div class="col-5">親権者:生年月日</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    :value="formatBirthDate(join_parent_obj[0]?.birth_date)"
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2" v-if="parent_frm_disp">
              <div class="col-5">親権者:性別</div>
              <div class="col-7">
                <div class="input-group">
                  <input
                    type="text"
                    :value="
                      get_list_label(join_parent_obj[0].sex_type, sex_type_cd)
                    "
                    :class="input_class_join"
                    :readonly="input_readonly_join"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-6">
                <label class="badge bg-secondary">商品名</label>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">単価</label>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">価格</label>
              </div>
            </div>
            <div
              class="row"
              v-for="draft_order in draft_orders"
              :key="draft_order"
            >
              <div class="col-6">
                <p class="form-control-plaintext">
                  {{ draft_order.license_label }}
                </p>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">単価</label>
                <p class="form-control-plaintext">
                  {{ number_format(draft_order.unit_price) }}
                </p>
              </div>
              <div class="col-3">
                <label class="badge bg-secondary">価格</label>
                <p class="form-control-plaintext">
                  {{ number_format(draft_order.list_price) }}
                </p>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-4 offset-4">
                <div class="d-grid" v-if="action_sw">--更新中--</div>
                <div class="d-grid" v-else>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="app_update_join()"
                  >
                    入会承認する
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="request_circuit" class="">
          <div
            class="container mb-2 border-bottom"
            v-for="variant in get_selected_variants_filter(
              { join_3hour: 1 },
              {},
              1
            )"
            :key="variant"
          >
            <div class="row">
              <div>サーキット照会依頼</div>
            </div>
            <div class="row mb-2">
              <div class="col-4">氏名</div>
              <div class="col-4">
                <p class="form-control-plaintext">
                  {{
                    (get_app_item('mfj_member_data@name_1') || {})
                      .application_value
                  }}
                </p>
              </div>
              <div class="col-4">
                <p class="form-control-plaintext">
                  {{
                    (get_app_item('mfj_member_data@name_2') || {})
                      .application_value
                  }}
                </p>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">依頼日時</div>
              <div class="col-8">
                {{
                  variant.join_3hour_circuit_chk_req_date
                    ? variant.join_3hour_circuit_chk_req_date
                    : ''
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">依頼先</div>
              <div class="col-8">
                <dl>
                  <dt>サーキット</dt>
                  <dd>
                    {{
                      get_list_label(
                        variant.join_3hour_circuit_id,
                        circuit_list
                      )
                    }}
                  </dd>
                  <dt>メールアドレス</dt>
                  <dd>
                    {{
                      get_list_column(
                        variant.join_3hour_circuit_id,
                        circuit_list,
                        'mail_address'
                      )
                    }}
                  </dd>
                  <dt>担当</dt>
                  <dd>
                    {{
                      get_list_column(
                        variant.join_3hour_circuit_id,
                        circuit_list,
                        'manager_label'
                      )
                    }}
                  </dd>
                </dl>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">担当者記名</div>
              <div class="col-8">
                {{
                  variant.join_3hour_circuit_chk_ans_signature
                    ? variant.join_3hour_circuit_chk_ans_signature
                    : '--'
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">対応日時</div>
              <div class="col-8">
                {{
                  variant.join_3hour_circuit_chk_ans_date
                    ? variant.join_3hour_circuit_chk_ans_date
                    : '--'
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">照会結果</div>
              <div class="col-4">
                {{
                  variant.join_3hour_circuit_chk_ans_data_1
                    ? variant.join_3hour_circuit_chk_ans_data_1
                    : '--'
                }}
              </div>
              <div class="col-4">
                {{
                  variant.join_3hour_circuit_chk_ans_data_2
                    ? variant.join_3hour_circuit_chk_ans_data_2
                    : '--'
                }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-2 offset-5">
                <div class="d-grid">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="
                      app_update_communication_send_circuit(
                        variant.draft_order_id
                      )
                    "
                  >
                    確認依頼送信
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="request_correction">
          <div class="row">
            <div class="col-4">▼チェック箇所</div>
            <div class="col-8">▼依頼内容</div>
          </div>
          <div
            class="row mb-2"
            v-for="check_cd in app_check_items_correction"
            :key="check_cd"
          >
            <div class="col-4">
              {{ check_cd.label }}
            </div>
            <div class="col-8">
              <input
                type="text"
                class="form-control"
                v-model="check_cd.item_comment"
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-4">通信欄</div>
            <div class="col-8">
              <textarea
                class="form-control"
                v-model="app_checked_comment"
              ></textarea>
            </div>
          </div>
          <div
            class="row"
            v-if="chk_relation_type_editable('/application/data')"
          >
            <div class="col-4"></div>
            <div class="col-4">
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="app_update_communication('correction')"
                >
                  訂正依頼
                </button>
              </div>
            </div>
            <div class="col-2 offset-2">
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-light"
                  @click="close_request_form()"
                >
                  閉じる
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div>
          <button
            type="button"
            class="btn btn-outline-secondary btn-light"
            @click="close_request_form()"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="finish_mode">
      <div class="col-1"></div>
      <div class="col-10">
        <p class="alert alert-success">登録済です。</p>
      </div>
      <div class="col-1"></div>
    </div>
    <div class="row" v-else-if="charge_error_mode">
      <div class="col-2">
        <div class="d-grid">
          <button
            type="button"
            class="btn btn-light btn-outline-secondary"
            @click="back()"
          >
            戻る
          </button>
        </div>
      </div>
      <div class="col-6">
        <p class="alert alert-danger">
          処理エラーです。<br />
          申請データに会員情報が設定されていません。
        </p>
      </div>
      <div class="col-2">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button
            type="button"
            class="btn btn-primary"
            @click="app_back_type(100)"
          >
            申請巻戻し
          </button>
        </div>
      </div>
      <div class="col-2">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button type="button" class="btn btn-danger" @click="app_reject()">
            申請取消
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="isRejectData">
      <div class="col-2">
        <div class="d-grid">
          <button
            type="button"
            class="btn btn-light btn-outline-secondary"
            @click="back()"
          >
            戻る
          </button>
        </div>
      </div>
      <div class="col-8">
        <p class="alert alert-warning">取り消されたデータです。</p>
      </div>
    </div>
    <div class="row" v-else-if="charge_mode">
      <div class="col-2">
        <div class="d-grid">
          <button
            type="button"
            class="btn btn-light btn-outline-secondary"
            @click="back()"
          >
            戻る
          </button>
        </div>
      </div>
      <div class="col-8 text-center">
        <p class="alert alert-warning">決済待ちです。</p>
      </div>
      <div class="col-2">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button type="button" class="btn btn-danger" @click="app_reject()">
            申請取消
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="editable_mode && edit_mode">
      <div class="col-12 mb-4" v-if="chk_same_name_and_birthday">
        <p class="alert alert-warning">
          同一の氏名・生年月日の会員が存在します
        </p>
      </div>
      <div class="col-1" v-if="chk_relation_type_editable('/application/data')">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button
            type="button"
            class="btn btn-outline-secondary btn-light"
            @click="edit_cancel()"
          >
            対応解除
          </button>
        </div>
      </div>
      <div
        class="col-10"
        v-if="chk_relation_type_editable('/application/data')"
      >
        <div class="row">
          <div class="col">
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-info"
                @click="app_send_correction()"
              >
                訂正依頼
              </button>
            </div>
          </div>
          <div class="col">
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-info"
                @click="app_update_communication('save')"
              >
                途中保存
              </button>
            </div>
          </div>
          <div class="col">
            <div class="d-grid" v-if="chk_join">
              <button
                type="button"
                class="btn btn-primary"
                @click="app_set_join()"
              >
                入会承認確認
              </button>
            </div>
            <div class="d-grid" v-else>
              <span class="btn btn-secondary" disabled="disabled"
                >入会承認</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-1" v-if="chk_relation_type_editable('/application/data')">
        <div class="d-grid">
          <button type="button" class="btn btn-danger" @click="app_reject()">
            申請取消
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-else-if="editable_mode">
      <div class="col-2">
        <div class="d-grid">
          <button
            type="button"
            class="btn btn-light btn-outline-secondary"
            @click="back()"
          >
            戻る
          </button>
        </div>
      </div>
      <div
        class="col-4 offset-2"
        v-if="chk_relation_type_editable('/application/data')"
      >
        <div class="d-grid">
          <button type="button" class="btn btn-info" @click="edit_start">
            操作開始
          </button>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-else-if="
        app_data.application_check_type == 200 ||
        app_data.application_check_type == 100 ||
        app_data.application_check_type == 120 ||
        app_data.application_check_type == 340 ||
        app_data.application_check_type == 600
      "
    >
      <div class="col-10"></div>
      <div class="col-2">
        <div
          class="d-grid"
          v-if="chk_relation_type_editable('/application/data')"
        >
          <button
            type="button"
            class="btn btn-warning"
            @click="edit_cancel_force()"
          >
            強制解除
          </button>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <p class="alert alert-info">
          <span v-if="app_data.application_check_type == 100">申請中です</span>
          <span v-else-if="app_data.application_check_type == 120"
            >再申請されました</span
          >
          <span v-else-if="app_data.application_check_type == 200"
            >確認中です</span
          >
          <span v-else-if="app_data.application_check_type == 300"
            >サーキット回答待です</span
          >
          <span v-else-if="app_data.application_check_type == 340"
            >サーキット回答済です</span
          >
          <span v-else-if="app_data.application_check_type == 360"
            >書類待ちです</span
          >
          <span v-else-if="app_data.application_check_type == 400"
            >決済待です</span
          >
          <span v-else-if="app_data.application_check_type == 403"
            >決済中です</span
          >
          <span v-else-if="app_data.application_check_type == 420"
            >決済支払待ち</span
          >
          <span v-else-if="app_data.application_check_type == 423"
            >コンビニ支払済</span
          >
          <span v-else-if="app_data.application_check_type == 426"
            >コンビニ支払済</span
          >
          <span v-else-if="app_data.application_check_type == 430"
            >アンケート未回答</span
          >
          <span v-else-if="app_data.application_check_type == 440"
            >手続完了</span
          >
          <span v-else-if="app_data.application_check_type == 500">完了</span>
          <span v-else-if="app_data.application_check_type == 600"
            >訂正依頼中</span
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import config from '../../../const'
import Common from '../../../common/common'
import ImageWithZoom from '@/components/molecules/ImageWithZoom.vue'

export default {
  name: 'AppFormView_1000',
  components: {
    ImageWithZoom
  },
  data: function () {
    return {
      PREF_CD_LIST: config.PREF_CD_LIST,
      rd_frm_disp: null,
      app_checked_items: [],
      app_checked_comment: '',
      action_mode: 'view',
      request_type: '',
      ownchk_list: [
        {
          key: 0,
          label: '保有していない'
        },
        {
          key: 1,
          label: '保有していた'
        }
      ],
      app_com_items_disp: [],
      app_com_max_disp: false,
      member_document: '',
      parent_document: '',

      request_license_no: '',

      join_obj: {},
      join_profile_obj: [],
      join_assets_obj: [],
      join_circuit_license_obj: [],
      join_parent_obj: [],
      join_license_obj: [],

      action_sw: false,
      chk_same_name_and_birthday_val: false
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    // 画像のURLを取得するヘルパーメソッド
    getImageSrc(pathKey) {
      const imageData = this.get_app_item(`mfj_member_assets@${pathKey}`)
      return imageData?.application_value || ''
    },

    // 有効な画像があるかチェック
    hasValidImage(pathKey) {
      const imageData = this.get_app_item(`mfj_member_assets@${pathKey}`)
      return imageData && imageData.application_value
    },

    // 画像読み込みエラー時の処理
    handleImageError(error) {
      console.error('画像の読み込みに失敗しました:', error)
      // エラー処理（必要に応じてユーザーに通知など）
    },
    // 参加OK
    async app_update_stock(hold_flg) {
      const params =
        hold_flg == 1
          ? { ...this.get_license_no_stock }
          : { ...this.get_license_no_stock_input }
      params.hold_flg = hold_flg

      const post_url =
        config.BASE_API_URL + '/license_no_stock/edit/' + params.id

      return await this.basicPosts_I(post_url, params)
        .then(async response => {
          let res = false
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            res = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            // console.log(
            //   'error update status 500',
            //   response.data.alert.error_obj
            // )
            res = false
          } else {
            // console.log('error update status 200 error')
            res = false
          }
          // console.log('app_update_stock', res)
          return res
        })
        .catch(err => {
          // console.log(err)
        })
        .finally(async () => {
          this.$emit('parentFuncReloadStock')
          this.$forceUpdate()
        })
    },
    async toggle_communication(com_id) {
      if (this.chk_items_disp(com_id)) {
        const idx = this.app_com_items_disp.findIndex(tmp => tmp == com_id)
        this.app_com_items_disp.splice(idx, 1)
      } else if (typeof this.app_com_items_disp === 'object') {
        this.app_com_items_disp.push(com_id)
      }
    },
    async toggle_communication_max() {
      if (this.app_com_max_disp) {
        this.app_com_max_disp = false
      } else {
        this.app_com_max_disp = true
      }
    },
    async toggle_check_action(key) {
      // console.log('toggle_check_action', key)
      // console.log(
      //   'toggle_check_action this.app_check_items1',
      //   this.app_checked_items
      // )
      if (this.chk_checked_item(key)) {
        const idx =
          typeof this.app_checked_items === 'object'
            ? this.app_checked_items.findIndex(item => item == key)
            : false
        if (idx >= 0) {
          this.app_checked_items.splice(idx, 1)
        }
      } else {
        this.app_checked_items.push(key)
      }
      this.$forceUpdate()
      // console.log(
      //   'toggle_check_action this.app_check_items2',
      //   this.app_checked_items
      // )
    },
    async on_check_wrap_action(key) {
      await this.toggle_check_action(key)
      if (key == 'm_idcard_photo') {
        // チェックが入った時は関連項目のチェックを外す
        // チェックが外れた時は関連項目のチェックを入れる
        const shouldCheck = this.chk_checked_item('m_idcard_photo')

        // 関連項目のチェック状態を一括で更新
        const relatedItems = ['m_name', 'm_yomi', 'm_birth_date', 'm_sex_type']
        for (const item of relatedItems) {
          if (this.chk_checked_item(item) !== shouldCheck) {
            await this.toggle_check_action(item)
          }
        }
      }
      if (key == 'parent_idcard_photo') {
        // 親権者の場合も同様
        const shouldCheck = this.chk_checked_item('parent_idcard_photo')

        const relatedItems = [
          'parent_name',
          'parent_yomi',
          'parent_birth_date',
          'parent_sex_type'
        ]
        for (const item of relatedItems) {
          if (this.chk_checked_item(item) !== shouldCheck) {
            await this.toggle_check_action(item)
          }
        }
      }
    },
    async app_back_type(check_type) {
      this.update_app_check_type(check_type, 'back')
    },
    async app_reject() {
      this.update_app_cancel('申請取消')
    },
    async app_update() {
      this.update_app_check_type(false, '更新')
    },
    async app_wait_parent_accept() {
      this.update_app_check_type(360, '書類待ち')
    },

    async set_communication_param(type) {
      const params = {
        id: 0,
        stat: 1,
        application_id: (this.app_data || {}).id ? (this.app_data || {}).id : 0,
        application_type: 1000,
        mail_address: '',
        manage_id: this.$store.state.auth.userId,
        comment:
          type == 'save'
            ? '途中保存'
            : type == 'join'
            ? '入会承認'
            : type == 'circuit'
            ? '確認依頼'
            : this.app_checked_comment,
        items: [],
        // draft_ordersの情報を追加
        draft_orders: this.draft_orders.map(order => ({
          id: order.id,
          list_price: order.list_price,
          license_label: order.license_label,
          sub_label: order.sub_label,
          unit_price: order.unit_price
        }))
      }
      const tmp_item = {
        id: 0,
        stat: 1,
        application_id: (this.app_data || {}).id ? (this.app_data || {}).id : 0,
        communication_id: 0,
        application_check_cd: '',
        check_flg: '',
        application_label: '',
        item_comment: ''
      }
      if (
        typeof this.app_check_items === 'object' &&
        Object.keys(this.app_check_items).length > 0
      ) {
        Object.values(this.app_check_items).forEach(check_item => {
          const item = { ...tmp_item }
          item.application_check_cd = check_item.key
          if (this.chk_checked_item(check_item.key)) {
            item.check_flg = 1
          } else {
            item.check_flg = 0
            item.item_comment =
              type == 'correction' ? check_item.item_comment : ''
          }
          params.items.push(item)
        })
      }
      return params
    },
    async app_update_communication_send_circuit(draft_order_id) {
      // await this.app_update_communication('circuit');
      const params = this.draft_orders.find(
        draft_order => draft_order.draft_order_id == draft_order_id
      )
      if (params) {
        params.join_3hour_circuit_chk_req_manage_id =
          this.$store.state.auth.userId
        params.join_3hour_circuit_chk_req_date = Common.getNowDateStr()
        this.$emit('parentFuncCircuitChk', params, 'circuit')
        await this.close_request_form()
      } else {
        alert('サーキット確認できません')
      }
    },
    async app_update_communication(type) {
      const params = await this.set_communication_param(type)
      this.$emit('parentFuncAppUpdateCommunication', params, type)
      await this.close_request_form()
    },

    // form開ける
    async app_send_correction() {
      Common.moveToTop()
      this.request_type = 'correction'
    },
    async app_send_circuit_check() {
      Common.moveToTop()
      this.request_type = 'circuit'
    },
    // form閉じる
    async close_request_form() {
      Common.moveToTop()
      this.request_type = ''
      // this.update_app_check_type(300, 'サーキット依頼状態');
    },
    async load_same_name_and_birthday() {
      // application_check_type=200でないと承認させない。
      const chk_param = {
        stat: [1]
      }
      if (this.app_data?.m_id) {
        chk_param.not_ids = [this.app_data?.m_id]
      }
      chk_param.birth_date = (
        this.get_app_item('mfj_member_data@birth_date') || {}
      ).application_value
      const name_1 = (this.get_app_item('mfj_member_data@name_1') || {})
        .application_value
      const name_2 = (this.get_app_item('mfj_member_data@name_2') || {})
        .application_value
      let like_name = ''
      if (name_1) like_name += name_1
      if (name_2) like_name += name_2
      chk_param.like_name = like_name
      console.log('load_same_name_and_birthday chk_param', chk_param)
      const same_name_birth_chk = await this.basicPosts_S(
        // config.BASE_API_URL + '/member/lists',
        config.BASE_API_URL + '/member/chk_same_birthday',
        chk_param
      )
        .then(async response => {
          console.log('load_same_name_and_birthday response', response)
          // レスポンスの検証
          if (
            typeof response?.data === 'object' &&
            response?.data?.status == 200
          ) {
            return true
          } else {
            return false
          }
        })
        .catch(async err => {
          console.log(err)
          return false
        })
        .finally(async () => {})

      const chk_param2 = {
        stat: [1],
        birth_date_cus: chk_param.birth_date,
        like_name_cus: chk_param.like_name
      }
      if (this.app_data?.id) {
        chk_param2.not_ids = [this.app_data?.id]
      } else {
        chk_param2.not_ids = [0]
      }
      const same_name_birth_chk2 = !same_name_birth_chk
        ? await this.basicPosts_S(
            // config.BASE_API_URL + '/member_application/lists',
            config.BASE_API_URL + '/member_application/chk_same_birthday',
            chk_param2
          )
            .then(async response => {
              console.log('load_same_name_and_birthday2 response', response)
              // レスポンスの検証
              if (
                typeof response?.data === 'object' &&
                response?.data?.status == 200
              ) {
                return true
              } else {
                return false
              }
            })
            .catch(async err => {
              console.log(err)
              return false
            })
            .finally(async () => {})
        : false

      this.chk_same_name_and_birthday_val = same_name_birth_chk
        ? same_name_birth_chk
        : same_name_birth_chk2
        ? same_name_birth_chk2
        : false
    },

    // 参加OK
    async app_update_join() {
      if (this.action_sw) {
        return false
      } else {
        await this.set_action_sw(true)
      }

      // application_check_type=200でないと承認させない。
      const chk_param = {
        id: this.app_data.id
      }
      const app_join_chk = await this.basicPosts_S(
        config.BASE_API_URL + '/member_application/join_chk',
        chk_param
      )
        .then(async response => {
          // レスポンスの検証
          if (
            typeof response?.data === 'object' &&
            response?.data?.status == 200
          ) {
            return true
          } else {
            return false
          }
        })
        .catch(async err => {
          console.log(err)
          return false
        })
      if (!app_join_chk) {
        alert('この申請は承認できません。')
        await this.close_request_form()
        return
      }

      const params = this.join_obj
      // 退避するか否か
      params.continue_data_save_type = 1
      // params.login_pass = params.license_no;
      params.profile =
        typeof this.join_profile_obj === 'object' &&
        this.join_profile_obj.length > 0
          ? this.join_profile_obj
          : false
      params.member_assets =
        typeof this.join_assets_obj === 'object' &&
        this.join_assets_obj.length > 0
          ? this.join_assets_obj
          : false
      params.circuit_license =
        typeof this.join_circuit_license_obj === 'object' &&
        this.join_circuit_license_obj.length > 0
          ? this.join_circuit_license_obj
          : false
      params.member_parent =
        typeof this.join_parent_obj === 'object' &&
        this.join_parent_obj.length > 0
          ? this.join_parent_obj
          : false
      params.member_license =
        typeof this.join_license_obj === 'object' &&
        this.join_license_obj.length > 0
          ? this.join_license_obj
          : false
      params.insurance =
        typeof this.join_insurance_obj === 'object' &&
        this.join_insurance_obj.length > 0
          ? this.join_insurance_obj
          : false
      console.log('app_update_join params', params)
      // return true
      const post_url = config.BASE_API_URL + '/member/add'

      let m_id = false
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('app_update_join basicpost response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            m_id = response.data.body[0].id
            await this.app_order(m_id)
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            m_id = false
          } else {
            console.log('error update status 200 error')
            m_id = false
          }
        })
        .catch(err => {
          // console.log(err)
        })
        .finally(async () => {
          const c_params = await this.set_communication_param('join')
          this.$emit('parentFuncJoinMember', m_id, c_params)
          await this.close_request_form()
          await this.set_action_sw(false)
          this.$forceUpdate()
        })
    },
    async set_action_sw(sw) {
      this.action_sw = sw
    },
    async app_order(m_id) {
      const post_url = config.BASE_API_URL + '/sales/add'
      const params = {
        id: 0,
        m_id: m_id,
        application_id: this.app_data.id,
        regist_id: this.regist_data.id,
        amount: 0,
        sales_type: 'regist',
        sales_orders: []
      }

      if (typeof this.draft_orders === 'object') {
        Object.values(this.draft_orders).forEach(draft_order => {
          params.sales_orders.push({
            id: 0,
            sales_id: 0,
            application_id: this.app_data.id,
            variant_id: draft_order.variant_id,
            sports_year: draft_order.sports_year,
            unit_price: draft_order.unit_price,
            num: draft_order.num,
            list_price: draft_order.list_price
          })
          params.amount += parseInt(draft_order.list_price)
          // insurance
          // commission
        })
      }

      let result = false
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            // console.log(
            //   'error update status 500',
            //   response.data.alert.error_obj
            // )
            result = false
          } else {
            // console.log('error update status 200 error')
            result = false
          }
        })
        .catch(err => {
          // console.log(err)
        })
        .finally(async () => {
          if (result)
            // console.log('result')
            this.$forceUpdate()
        })
    },
    async app_set_join() {
      this.request_type = 'join'
      if (!(this.get_license_no_stock || {}).license_no) {
        alert('ライセンスNoが不正です')
        return false
      }
      this.request_license_no = this.get_license_no_stock.license_no
      // member_data
      this.join_obj = {
        id: 0,
        // license_no: (this.get_app_item('mfj_member_data@license_no') || {}).application_value,
        // affiliation: (this.get_app_item('mfj_member_data@affiliation') || {}).application_value,
        license_no: this.request_license_no,
        affiliation: 'mfj',
        login_id: (this.get_app_item('mfj_member_data@login_id') || {})
          .application_value,
        login_pass: (this.get_app_item('mfj_member_data@login_pass') || {})
          .application_value,
        // login_pass: (this.get_app_item('mfj_member_data@login_pass') || {}).application_value,
        // login_pass: '',
        name_1: (this.get_app_item('mfj_member_data@name_1') || {})
          .application_value,
        name_2: (this.get_app_item('mfj_member_data@name_2') || {})
          .application_value,
        yomi_1: (this.get_app_item('mfj_member_data@yomi_1') || {})
          .application_value,
        yomi_2: (this.get_app_item('mfj_member_data@yomi_2') || {})
          .application_value,
        birth_date: (this.get_app_item('mfj_member_data@birth_date') || {})
          .application_value,
        sex_type: (this.get_app_item('mfj_member_data@sex_type') || {})
          .application_value,
        identify_type: (
          this.get_app_item('mfj_member_data@identify_type') || {}
        ).application_value,
        application_date: (
          this.get_app_item('mfj_member_data@application_date') || {}
        ).application_value,
        permission_date: (
          this.get_app_item('mfj_member_data@permission_date') || {}
        ).application_value
      }

      this.join_profile_obj.push({
        id: 0,
        postal_cd: (this.get_app_item('mfj_member_profile@postal_cd') || {})
          .application_value,
        pref_cd: (this.get_app_item('mfj_member_profile@pref_cd') || {})
          .application_value,
        address_1: (this.get_app_item('mfj_member_profile@address_1') || {})
          .application_value,
        address_2: (this.get_app_item('mfj_member_profile@address_2') || {})
          .application_value,
        tel_1: (this.get_app_item('mfj_member_profile@tel_1') || {})
          .application_value,
        tel_2: (this.get_app_item('mfj_member_profile@tel_2') || {})
          .application_value,
        mail_1: (this.get_app_item('mfj_member_profile@mail_1') || {})
          .application_value,
        mail_2: (this.get_app_item('mfj_member_profile@mail_2') || {})
          .application_value,
        mail_flg: (this.get_app_item('mfj_member_profile@mail_flg') || {})
          .application_value
      })

      const asset_type_lists = [
        false,
        400,
        400,
        100,
        450,
        450,
        150,
        false,
        false,
        false,
        910
      ]
      if (!this.parent_frm_disp) {
        asset_type_lists[4] = false
        asset_type_lists[5] = false
        asset_type_lists[6] = false
      }
      asset_type_lists.forEach((type_cd, index) => {
        if (type_cd) {
          this.join_assets_obj.push({
            id: 0,
            type: type_cd,
            path: (this.get_app_item('mfj_member_assets@path' + index) || {})
              .application_value
          })
        }
      })
      this.join_circuit_license_obj.push({
        id: 0,
        circuit_id: (
          this.get_app_item('mfj_member_circuit_license.circuit_id') || {}
        ).application_value,
        circuit_license_no: (
          this.get_app_item('mfj_member_circuit_license.circuit_license_no') ||
          {}
        ).application_value
      })
      // parent
      this.join_parent_obj.push({
        id: 0,
        license_no: (this.get_app_item('mfj_member_parent@license_no') || {})
          .application_value,
        name_1: (this.get_app_item('mfj_member_parent@name_1') || {})
          .application_value,
        name_2: (this.get_app_item('mfj_member_parent@name_2') || {})
          .application_value,
        yomi_1: (this.get_app_item('mfj_member_parent@yomi_1') || {})
          .application_value,
        yomi_2: (this.get_app_item('mfj_member_parent@yomi_2') || {})
          .application_value,
        birth_date: (this.get_app_item('mfj_member_parent@birth_date') || {})
          .application_value,
        sex_type: (this.get_app_item('mfj_member_parent@sex_type') || {})
          .application_value,
        identify_type:
          // this.get_app_item('mfj_member_parent@identify_type') || {}
          (this.get_app_item('mfj_outdb_data@parent_path_type') || {})
            .application_value
      })

      //license,hokenはここではなく、user側で行う
      // const join_license_tmp = []
      // const join_insurance_tmp = []
      // this.draft_orders.map(order => {
      //   if (order.article_category == 1) {
      //     join_insurance_tmp.push({
      //       id: 0,
      //       stat: 1,
      //       insurance_type: order.variant_sort,
      //       sports_year: order.sports_year,
      //       start_date: '',
      //       end_date: ''
      //     })
      //   } else if ([3, 4, 5].includes(parseInt(order.article_category))) {
      //     join_license_tmp.push({
      //       id: 0,
      //       stat: 1,
      //       m_id: 0,
      //       fixed: 0,
      //       payment_flg: 0,
      //       license_cd: order.license_id,
      //       license_year: order.sports_year,
      //       license_term_cd: 0,
      //       license_term_start_date: '',
      //       license_term_end_date: ''
      //     })
      //     if (
      //       order.sub_license_id &&
      //       parseInt(order.sub_license_id) > 0 &&
      //       !join_license_tmp.find(
      //         tmp => tmp.license_cd == order.sub_license_id
      //       )
      //     ) {
      //       join_license_tmp.push({
      //         id: 0,
      //         stat: 1,
      //         m_id: 0,
      //         fixed: 0,
      //         payment_flg: 0,
      //         license_cd: order.sub_license_id,
      //         license_year: order.sports_year,
      //         license_term_cd: 0,
      //         license_term_start_date: '',
      //         license_term_end_date: ''
      //       })
      //     }
      //   }
      // })

      // this.join_license_obj = join_license_tmp
      // this.join_insurance_obj = join_insurance_tmp
    },
    // 通常処理開始
    async edit_start() {
      this.$emit('parentFuncSwitchLoading', true)
      this.$emit('parentFuncEditStart')
    },
    async edit_cancel() {
      this.$emit('parentFuncSwitchLoading', true)
      this.$emit('parentFuncEditCancel')
    },
    async edit_cancel_force() {
      this.$emit('parentFuncSwitchLoading', true)
      this.$emit('parentFuncEditCancel')
    },

    // application_check_typeを更新する(ステータス)
    async update_app_check_type(check_type, type_label) {
      const params = { ...this.app_data }
      if (check_type) params.application_check_type = check_type
      this.$emit('parentFuncAppUpdate', params, type_label)
    },
    // application_check_typeを更新する(ステータス)
    async update_app_cancel(type_label) {
      const params = { ...this.app_data }
      params.stat = 9
      this.$emit('parentFuncAppUpdate', params, type_label)
    },

    chk_val_(value) {
      if (value) {
        return value
      }
      return '--'
    },
    formatBirthDate(date) {
      if (!date || date === '0000-00-00' || date === 'NULL') {
        return ''
      }

      const isValidDate = !isNaN(new Date(date).getTime())
      if (!isValidDate) {
        return ''
      }

      return date
    },

    formatWarekiDate(date) {
      if (!date || date === '0000-00-00' || date === 'NULL') {
        return ''
      }

      const isValidDate = !isNaN(new Date(date).getTime())
      if (!isValidDate) {
        return ''
      }

      return this.get_wareki_bs(date)
    },
    calc_sports_age(birthDate, sportsYear) {
      console.log('Birth Date:', birthDate)
      console.log('Sports Year:', sportsYear)

      if (!birthDate || !sportsYear) {
        console.error('Invalid input for age calculation')
        return null
      }

      const birth = new Date(birthDate)
      const year = parseInt(sportsYear)
      const startOfYear = new Date(year, 3, 1) // 4月1日
      const endOfYear = new Date(year + 1, 2, 31) // 翌年の3月31日

      let age = year - birth.getFullYear()

      // 誕生日が年度の開始日より後の場合、1歳引く
      if (birth > startOfYear) {
        age--
      }

      return age
    }
  },
  props: {
    app_data: {
      type: Object,
      default: () => {}
    },
    regist_data: {
      type: Object,
      default: () => {}
    },
    app_check_cd: {
      type: Array,
      default: () => []
    },
    app_check_type: {
      type: Array,
      default: () => []
    },
    sex_type_cd: {
      type: Array,
      default: () => []
    },
    circuit_list: {
      type: Array,
      default: () => []
    },
    draft_orders: {
      type: Array,
      default: () => []
    },
    pref_cd: {
      type: Array,
      default: () => []
    },
    member_document_cd: {
      type: Array,
      default: () => []
    },
    license_no_stock: {
      type: Array,
      default: () => []
    },
    step_mode: {
      type: String,
      default: 'kiyaku'
    }
  },
  computed: {
    isRejectData: function () {
      if (this.app_data?.stat == 9) {
        return true
      }
      return false
    },
    birthdate_is_valid: function () {
      const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/
      return !regex.test(
        (this.get_app_item('mfj_member_data@birth_date') || {})
          .application_value
      )
    },
    isImage: function () {
      return function (url_path) {
        return /\.(jpg|jpeg|png|gif|bmp|webp|svg|avif)$/i.test(url_path)
      }
    },
    ...mapState({}),
    chk_same_name_and_birthday: function () {
      return this.chk_same_name_and_birthday_val
    },
    request_license_no_readonly: function () {
      if (!this.get_license_no_stock) {
        return false
      } else if (this.stock_action_sw) {
        return true
      }
      return true
    },
    stock_action_sw: function () {
      if (
        this.request_license_no == '' ||
        (this.request_license_no != '' &&
          this.get_license_no_stock.license_no == this.request_license_no)
      ) {
        return true
      }
      return false
    },
    get_license_no_stock: function () {
      const tmps = this.license_no_stock.filter(stock => stock.used_flg == 0)
      return typeof tmps === 'object' && tmps[0] ? tmps[0] : false
    },
    get_license_no_stock_input: function () {
      const tmps = this.license_no_stock.filter(
        stock => stock.license_no == this.request_license_no
      )
      return typeof tmps === 'object' && tmps[0] ? tmps[0] : false
    },

    // get_selected_variants_filter: function () {
    //   const draft_orders = this.draft_orders
    //   return function (params) {
    //     if (typeof draft_orders === 'object') {
    //       return draft_orders.filter(draft_order => {
    //         let ret = false
    //         if (typeof params === 'object') {
    //           Object.keys(params).forEach(key => {
    //             if (draft_order[key] == params[key]) {
    //               ret = true
    //             }
    //           })
    //         }
    //         return ret
    //       })
    //     }
    //     return false
    //   }
    // },
    // params: いずれか一致
    // r_params: 全一致
    // limit: 取得数
    get_selected_variants_filter: function () {
      const draft_orders = this.draft_orders
      return function (params, r_params, limit) {
        if (typeof draft_orders === 'object') {
          const tmpss = draft_orders.filter(variant => {
            let ret = false
            if (typeof params === 'object') {
              Object.keys(params).forEach(key => {
                if (variant[key] == params[key]) {
                  ret = true
                }
              })
            }
            return ret
          })
          // console.log('get_selected_variants_filter r_params', r_params)
          const tmps =
            typeof r_params === 'object' && Object.keys(r_params).length > 0
              ? tmpss.filter(variant => {
                  let ret = true
                  Object.keys(r_params).forEach(key => {
                    if (variant[key] != r_params[key]) {
                      ret = false
                    }
                  })
                  return ret
                })
              : tmpss
          if (
            limit !== false &&
            typeof tmps === 'object' &&
            tmps.length >= limit
          ) {
            return tmps.splice(0, limit)
          } else {
            return tmps
          }
        }
        return false
      }
    },
    // 3時間証明表示
    join_3hour_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => draft_order.join_3hour == 1)
      ) {
        return true
      }
      return false
    },
    // 3時間証明サーキット確認済
    join_3hour_frm_circuit_chk_ok: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => {
          if (
            draft_order.join_3hour == 1 &&
            draft_order.join_3hour_circuit_chk_ans_data_1 == 1 &&
            draft_order.join_3hour_circuit_chk_ans_data_2 == 1
          ) {
            return true
          }
          return false
        })
      ) {
        return true
      }
      return false
    },
    // 講習会
    join_seminar_frm_disp: function () {
      if (
        this.join_seminar_web_frm_disp ||
        this.join_seminar_circuit_frm_disp
      ) {
        return true
      }
      return false
    },
    // Web講習
    join_seminar_web_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => draft_order.join_seminar_web == 1)
      ) {
        return true
      }
      return false
    },
    // 対面講習選択
    join_seminar_circuit_chk_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(
          draft_order => draft_order.join_seminar_type == 'circuit'
        )
      ) {
        return true
      }
      return false
    },
    // 対面講習
    join_seminar_circuit_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(
          draft_order => draft_order.join_seminar_circuit == 1
        )
      ) {
        return true
      }
      return false
    },
    // 親権者(MPCのみ)
    parent_frm_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(draft_order => draft_order.join_parent_frm == 1)
      ) {
        return true
      }
      return false
    },
    // 参加承諾書(18歳以下)
    parent_accept_disp: function () {
      if (
        typeof this.draft_orders === 'object' &&
        this.draft_orders.find(
          draft_order =>
            draft_order.join_parent_accept > 0 &&
            draft_order.join_parent_accept >=
              this.calc_sports_age_2(
                draft_order.sports_year,
                (this.get_app_item('mfj_member_data@birth_date') || {})
                  .application_value
              )
        )
      ) {
        return this.app_check_cd.find(cd => cd.key == 'parent_accept')
          ? true
          : false
      }
      return false
    },
    //
    chk_items_disp: function () {
      const app_com_items_disp = this.app_com_items_disp
      return function (com_id) {
        if (app_com_items_disp.includes(com_id)) {
          return true
        }
        return false
      }
    },
    chk_join: function () {
      let chk = true
      if (typeof this.app_check_items === 'object') {
        Object.values(this.app_check_items).forEach(check_cd => {
          if (this.chk_checked_item(check_cd.key) && chk == true) {
            chk = true
          } else {
            chk = false
          }
        })
      }
      let chk2 = true
      if (typeof this.app_check_cd === 'object') {
        Object.values(this.app_check_cd).forEach(check_cd => {
          if (this.chk_checked_item(check_cd.key) && chk2 == true) {
            chk2 = true
          } else {
            chk2 = false
          }
        })
      }

      return chk ? chk : chk2 ? chk2 : chk2
    },
    app_check_items: function () {
      const items = [...this.app_check_cd]
        .map(check_cd => {
          check_cd.item_comment = ''
          return check_cd
        })
        //
        .filter(item => {
          if (item.key == 'm_join_3hour') {
            return this.join_3hour_frm_disp ? true : false
          }
          if (item.key == 'm_join_seminar') {
            return this.join_seminar_circuit_chk_disp ? true : false
          }
          if (item.key.indexOf('parent') < 0) {
            return true
          } else if (this.parent_frm_disp && item.key.indexOf('parent') >= 0) {
            return true
          }
          return false
        })
      // 取得ライセンスに応じて削除する
      // ロードレースF、国内以外は３時間は削除
      // 成人であれば親権者系は必要なし
      // MPC以外は親権者いらんとか
      return items
    },
    app_check_items_correction: function () {
      const items = this.app_check_items.filter(item => {
        if (!this.chk_checked_item(item.key)) {
          return true
        }
        return false
      })
      // 取得ライセンスに応じて削除する
      // ロードレースF、国内以外は３時間は削除
      // 成人であれば親権者系は必要なし
      // MPC以外は親権者いらんとか
      return items
    },
    get_app_check_item: function () {
      const items = this.app_check_items
      return function (key) {
        if (
          typeof items === 'object' &&
          items.find(item => item.application_key == key)
        ) {
          return items.find(item => item.application_key == key)
        }
        return false
      }
    },
    chk_checked_item: function () {
      const checked_items = this.app_checked_items
      const checked = (this.app_data || {}).checked
      return function (key) {
        // const item = get_item(key);
        if (typeof checked === 'object' && checked.includes(key)) {
          return true
        } else if (
          typeof checked_items === 'object' &&
          checked_items.includes(key)
        ) {
          return true
        }
        // console.log('not chk_checked_item', key)
        return false
      }
    },
    get_class_check_item_btn: function () {
      const check = this.chk_checked_item
      return function (key) {
        if (check(key)) {
          return 'btn btn-sm btn-warning'
        }
        return 'btn btn-sm btn-light btn-outline-secondary'
      }
    },
    get_class_check_item_icon: function () {
      const check = this.chk_checked_item
      return function (key) {
        if (check(key)) {
          return 'bi bi-check-square'
        }
        return 'bi bi-square'
      }
    },
    app_items: function () {
      return (this.app_data || {}).items ? (this.app_data || {}).items : false
    },
    get_app_item: function () {
      const items = this.app_items
      return function (app_key) {
        if (
          typeof items === 'object' &&
          items.find(item => item.application_key == app_key)
        ) {
          return items.find(item => item.application_key == app_key)
        }
        return false
      }
    },
    get_app_item_value: function () {
      const get_obj = this.get_app_item
      return function (app_key) {
        const get_item = get_obj(app_key)
        if (get_item) {
          return (get_item || {}).application_value
        }
        return false
      }
    },
    get_list_label: function () {
      return function (key, lists) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {}).label
        }
        return key
      }
    },
    get_list_column: function () {
      return function (key, lists, column) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {})[column] || ''
        }
        return key
      }
    },
    communication_sort: function () {
      return (this.app_data || {}).communications
        .map(communication => {
          if (!communication.items_disp) {
            communication.items_disp = false
          }
          return communication
        })
        .sort((a, b) => {
          if (parseInt(a.cre_date_num) > parseInt(b.cre_date_num)) {
            return -1
          } else {
            return 1
          }
        })
        .filter((communication, index) => {
          if (this.app_com_max_disp == false && index >= 5) {
            return false
          }
          return true
        })
    },
    input_class: function () {
      if (!this.root_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly: function () {
      if (!this.root_mode) {
        return true
      } else {
        return false
      }
    },
    input_class_join: function () {
      if (this.request_join) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly_join: function () {
      if (this.request_join) {
        return true
      } else {
        return false
      }
    },

    req_parent_accept: function () {
      if (
        ((this.app_data || {}).application_check_type == 200 ||
          (this.app_data || {}).application_check_type == 340) &&
        !this.chk_checked_item('parent_accept')
      ) {
        return true
      }
      return false
    },
    no_check_circuit: function () {
      if (
        (this.app_data || {}).application_check_type == 200 &&
        !this.chk_checked_item('m_rd_3hour_circuit')
        // ロードRF,ロード国内のみの処理
      ) {
        return true
      }
      return false
    },

    request_circuit: function () {
      return this.request_type == 'circuit' ? true : false
    },
    request_correction: function () {
      return this.request_type == 'correction' ? true : false
    },
    request_join: function () {
      return this.request_type == 'join' ? true : false
    },
    request_mode: function () {
      if (
        this.request_type == 'circuit' ||
        this.request_type == 'correction' ||
        this.request_type == 'join'
      ) {
        return true
      }
      return false
    },
    root_mode: function () {
      return false
    },
    editable_mode: function () {
      if (this.app_data.editable == 1) {
        return true
      }
      return false
    },
    finish_mode: function () {
      if (this.app_data.application_check_type == 500) {
        return true
      }
      return false
    },
    charge_mode: function () {
      if (
        this.app_data.application_check_type == 400 &&
        this.regist_data.m_id > 0
      ) {
        return true
      }
      return false
    },
    charge_error_mode: function () {
      if (
        this.app_data.application_check_type == 400 &&
        this.regist_data.m_id == 0
      ) {
        return true
      }
      return false
    },
    lock_mode: function () {
      if (this.app_data.editable == 0) {
        return true
      }
      return false
    },
    edit_mode: function () {
      if (
        this.app_data.edit_manage_id > 0 &&
        this.app_data.edit_manage_id == this.$store.state.auth.userId
      ) {
        return true
      }
      return false
    },
    reject_mode: function () {
      return this.step_mode == 'mfj_reject' ? true : false
    },
    approval_mode: function () {
      return this.step_mode == 'mfj_approval' ? true : false
    },
    success_mode: function () {
      return this.step_mode == 'success' ? true : false
    },
    error_mode: function () {
      return this.step_mode == 'error' ? true : false
    },
    currentSportsYear() {
      const currentYear = new Date().getFullYear()
      return currentYear // 現在の年度を返す
    }
  },

  watch: {
    app_data: async function () {
      console.log('watch app_data load_same_name_and_birthday')
      await this.load_same_name_and_birthday()
    }
  },
  async created() {},
  mounted: async function () {
    this.member_document = (
      this.get_app_item('mfj_member_data@identify_type') || {}
    ).application_value
    this.parent_document =
      // this.get_app_item('mfj_member_parent@identify_type') || {}
      (
        this.get_app_item('mfj_outdb_data@parent_path_type') || {}
      ).application_value
    console.log('mounted load_same_name_and_birthday')
  }
}
</script>
